import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box, Text } from '@hivewatch/dark'

import { NotificationSubtitle } from '@/features/notification'
import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationsTabTokens } from '../../styles/tokens'

export const FlagNotification = ({
  notification,
  onClick,
}: {
  notification: Notification
  onClick: () => void
}) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const tokens = getNotificationsTabTokens(colorScheme)
  return (
    <Box color={tokens.textPrimary} cursor='pointer' flex={1} onClick={onClick}>
      <Text
        data-testid='FlagNotification:header'
        lineClamp={2}
        mb={1.5}
        textStyle='label'
      >
        {t('common:ai_operator_has_flagged')}{' '}
        <Box as='span' color={tokens.incidentLink} textStyle='label'>
          {notification.incidentDisplayId} {notification.incidentName}
        </Box>{' '}
        {t('common:ai_operator_flagged_for_review')}
      </Text>
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        fontSize='11px'
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
    </Box>
  )
}
